import React from "react";
import ReactDOM from "react-dom";
import { configureStore } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import { connect } from "react-redux";
import FormError from "../../../FormError";
import { parsePhoneNumberFromString, AsYouType } from 'libphonenumber-js';

import {
    addPhoneRecipient,
    removePhoneRecipient,
    formatPhone,
    formatPhoneNatOrIntl
} from "../../../redux/FeedbackRedux";

class PhoneRecipients extends React.Component {
    constructor(props) {
        super(props);
        this.state = { phone: "", name: "", "phone_error": false };

        this.handleAddPhoneRecipient = this.handleAddPhoneRecipient.bind(this);
    }

    handleAddPhoneRecipient(event) {




        var phone = parsePhoneNumberFromString(this.state.phone, "US");

        if (!phone || !phone.isValid()) {
            this.setState({ "phone_error": __("Please enter a valid phone number.") });
            return;
        }

        if (this.props.phone_recipients.map((item, key) => item.value).includes(this.state.phone)) {
            this.setState({ "phone_error": __("This phone number is already in the list.") });
            return;
        }

        this.props.dispatch(addPhoneRecipient(this.state));

        this.setState({ phone: "", name: "" });
    }

    handleRemovePhoneRecipient(uuid, event) {
        event.preventDefault();
        this.props.dispatch(removePhoneRecipient({ uuid: uuid }));
    }

    handleKeyDown(event) {
        var update = event.target.value;

        if (this.state.phone.length < update.length) {
            update = formatPhone(update);
        }

        this.setState({
            phone: update,
            "phone_error": false
        });
    }

    render() {
        return (
            <div className="">
                <div className="pb-2">
                    <h5><b>{__('Text Messages')}:</b></h5>
                    <p className="">
                        {__("Non-registered users can receive a text message whenever Feedback is submitted for this business. The text will include the customer's information along with a link to view the Feedback. This function is primarily to be used by organizations that have more than one location and corporate employees want to be notified of every Feedback sent.")}.
                    </p>

                    <div className="d-flex mb-2 align-items-end filter-bar-wrapper">
                        <div className="w-100 row mt-2">
                            <div className="col-sm-6 px-3 mt-2">
                                <div className="input-group feedback-form-control mt-2">
                                    <input
                                        placeholder={__('Phone Number')}
                                        type="phone"
                                        className="form-control input"
                                        name="recipient_phone"
                                        value={this.state.phone}
                                        onChange={this.handleKeyDown.bind(this)}
                                        onKeyPress={e => { if (e.key === "Enter") { e.preventDefault(); this.handleAddPhoneRecipient(); } }}
                                    ></input>
                                </div>
                                <FormError error_message={this.state.phone_error}></FormError>
                            </div>

                            <div className="col-sm-6 px-3 mt-2">
                                <div className="input-group feedback-form-control mt-2">

                                    <input
                                        placeholder={__("Recipient First and Last Name")}
                                        type="text"
                                        className="form-control input"
                                        name="recipient_name"
                                        value={this.state.name}
                                        onChange={event =>
                                            this.setState({ name: event.target.value })
                                        }
                                        onKeyPress={e => { if (e.key === "Enter") { e.preventDefault(); this.handleAddPhoneRecipient(); } }}
                                    ></input>
                                </div>
                            </div>
                        </div>

                        <div className="text-right ml-2 mt-2">
                            <a
                                className="btn btn-sm btn-primary text-white text-nowrap"
                                onClick={this.handleAddPhoneRecipient}
                            >
                                <i className="fas fa-inbox-in mr-1"></i> {__('Add Phone Number To List')}
                            </a>
                        </div>
                    </div>

                    <h5>{__('Phone Number List: (click on a contact to remove them from the list)')}</h5>

                    <div className="row">
                        <div className="col-sm-12 d-flex">
                            {this.props.phone_recipients.map((item, key) => (
                                <div className="d-inline-block mr-2" key={item.uuid}>
                                    <div className="">
                                        <button
                                            href=""
                                            className="btn btn-secondary btn-sm"
                                            onClick={this.handleRemovePhoneRecipient.bind(
                                                this,
                                                item.uuid
                                            )}
                                        >
                                            {formatPhoneNatOrIntl(item.value)} {item.description ? "(" + item.description + ")" : ""}
                                        </button>
                                        <br></br>
                                        <br></br>
                                    </div>
                                </div>
                            ))}

                            {this.props.phone_recipients.length == 0 ? (
                                <div>{__('Empty')}</div>
                            ) : (
                                <div></div>
                            )}
                        </div>
                    </div>
                </div>
                <input
                    type="hidden"
                    name="phone_recipients"
                    value={JSON.stringify(this.props.phone_recipients)}
                ></input>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        phone_recipients: state.phone_recipients
    };
}

export default connect(mapStateToProps)(PhoneRecipients);
